import { render, staticRenderFns } from "./FormSeller.vue?vue&type=template&id=3e70a4ca&"
import script from "./FormSeller.vue?vue&type=script&lang=js&"
export * from "./FormSeller.vue?vue&type=script&lang=js&"
import style0 from "./FormSeller.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports